"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgExchange = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M18.537 18H3.002c-.67 0-1.004-.333-1.002-1 .002-.666.335-1 1-1h15.467l-1.137-1.137a1 1 0 011.414-1.414l2.879 2.879a1 1 0 010 1.414l-2.88 2.88a1 1 0 11-1.414-1.414L18.536 18zM5.607 6H21c.667-.003 1 .33 1 1.002 0 .671-.333 1.004-1 .998H5.537l1.207 1.208a1 1 0 11-1.414 1.414l-2.88-2.88a1 1 0 010-1.414l2.879-2.879a1 1 0 011.414 1.414L5.606 6z' }))); };
exports.default = SvgExchange;
//# sourceMappingURL=Exchange.js.map